import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useDropzone } from "react-dropzone";
import { ReactComponent as Profile } from "../../assets/AccountingModule/upload.svg";
import { Close } from "@mui/icons-material";
import color from "../../constants/color";

const DragAndDropMultiple = ({ handleUrl, isFrom, imgUrl, setimgUrl, disabled = false }) => {
  const [files, setFiles] = useState([]);
  const [imageUrls, setImageUrls] = useState(Array.isArray(imgUrl) ? imgUrl : []);
  const [error, setError] = useState("");

  const MAX_FILE_SIZE = 5 * 1024 * 1024;

  const onDrop = (acceptedFiles) => {
    if (disabled) return
    setError("");
    const validFiles = [];
    const validImageUrls = [];
    for (let file of acceptedFiles) {
      if (file.size > MAX_FILE_SIZE) {
        setError("Each file must be less than 5 MB.");
        continue;
      }
      validFiles.push(file);
      validImageUrls.push(URL.createObjectURL(file));
    }
    if (validFiles.length === 0) return;
    const updatedFiles = [...files, ...validFiles];
    const updatedImageUrls = [...imageUrls, ...validImageUrls];
    setFiles(updatedFiles);
    setImageUrls(updatedImageUrls);
    handleUrl(updatedFiles);
    if (setimgUrl) {
      setimgUrl(updatedImageUrls);
    }
  };

  const removeImage = (index) => {
    if (disabled) return
    const newFiles = [...files];
    const newImageUrls = [...imageUrls];
    newFiles.splice(index, 1);
    newImageUrls.splice(index, 1);

    setFiles(newFiles);
    setImageUrls(newImageUrls);
    if (imgUrl) {
      setimgUrl(newImageUrls)
    }
    // Send updated files to the handleUrl function

  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, disabled: disabled });

  return (
    <Box>
      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
        {imageUrls?.map((url, index) => (
          <Box key={index} sx={{ width: "30%", m: 0.5, position: "relative", opacity: disabled ? 0.6 : 1 }}><Box key={index} alt={`selected ${index}`} sx={{
            backgroundImage: `url(${url})`, backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
            backgroundRepeat: "no-repeat", width: "100%", height: "5em", borderRadius: "10px", mb: 1
          }} /><Close fontSize="18px" sx={{ position: "absolute", top: 3, right: 3, background: color.card, borderRadius: "100%" }} onClick={() => removeImage(index)} /></Box>
        ))}
      </Box>
      {/* <Box><Typography sx={{color: color.lightText, fontSize:"14px", mb:1}}>Choose file here</Typography></Box> */}
      <Box
        {...getRootProps()}
        sx={{
          width: "100%",
          height: isFrom === "edit" ? "100%" : "30%",
          border: "1px dashed #ccc",
          borderRadius: "5px",
          px: 1,
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          cursor: disabled ? "not-allowed" : "pointer",
          bgcolor: isDragActive && !disabled ? "#eee" : "transparent",
          flexDirection: "column",
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? "none" : "auto"

        }}
      >
        <input {...getInputProps()} multiple />

        {/* {isFrom === "edit" ? (
        <Box sx={styles.imageContainer}>
          {imageUrls.length > 0 ? (
            imageUrls.map((url, index) => (
              <Box key={index} sx={{width:"100%"}}><Box key={index} alt={`selected ${index}`} sx={{
                backgroundImage: `url(${url})`, backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat", width: "100%", height: "10em", borderRadius: "20px",
              }} /><Close /></Box>            
            ))
           
          ) : (
            <Avatar src={profileImg} alt="select" sx={{ width: "4em", height: "4em" }} />
          )}
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          {imageUrls.length > 0 ? (
            imageUrls.map((url, index) => (
              <Avatar key={index} src={url} alt={`selected ${index}`} sx={{ width: "3em", height: "3em", objectFit: "contain", mr: 1 }} />
            ))
          ) : null}
        </Box>
      )} */}

        {/* {isFrom == "edit" && ( */}
        <Box sx={{ my: 2, display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
          <Typography sx={{ border: "1px solid lightGray", alignItems: "center", px: "5%", fontSize: "14px", py: "1%", borderRadius: "5px", backgroundColor: color.primary, color: color.card }}>
            <Profile sx={{ mr: 1 }} /> Choose File
          </Typography>
          <Typography sx={{ ml: 1, fontSize: "12px" }}>
            {disabled ? "File selection disabled" : (isDragActive ? "Drop the files here" : "Or drag and drop file here.")}
          </Typography>
        </Box>
        {/* )} */}
      </Box>
      {error && (
        <Typography
          sx={{
            color: "#d32f2f",
            fontSize: "0.75rem",
            mt: "4px",
            ml: "14px",
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default DragAndDropMultiple;